module.exports = __webpack_public_path__ + "img/meeza.b8e00c56.png";